/**
 * Filter that is used in Comms Mgn page to return start from number for pagination
 */
(function() {
    'use strict';

    angular.module('app').filter('paginationStartFromFilter', function() {

        return function(input, start) {
            if(!input){
                return null;
            }

            start = +start; //parse to int
            return input.slice(start);
        }
    });
}());